import { useTranslation } from 'react-i18next'

import { FunnelSimpleIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import RegionsSelect from '@/metrics/components/RegionsSelect/RegionsSelect'

import TimeRangeSelect from '../TimeRangeSelect/TimeRangeSelect'
import { getDateFormatted, getFilters } from './helpers'
import * as Styles from './styles'

const FiltersSection = ({ filters, onChange, regions }) => {
  const { t } = useTranslation()

  const handleChangeTimeRange = value => {
    onChange(getFilters(filters, value))
  }

  const handleChangeRegion = value => {
    onChange({ ...filters, regionId: value })
  }

  const handleChangeDateRanges = dates => {
    const { startDate, endDate } = dates

    onChange({
      ...filters,
      timeRange: 'custom',
      startDate: getDateFormatted(startDate),
      endDate: getDateFormatted(endDate),
    })
  }

  return (
    <Styles.FiltersContainer>
      <Styles.FiltersSubContainer>
        <FunnelSimpleIcon size={24} />
        <Text type="titleM">{t('Filtros')}</Text>
      </Styles.FiltersSubContainer>
      <Styles.FiltersSubContainer>
        <TimeRangeSelect
          value={filters?.timeRange}
          onChange={handleChangeTimeRange}
          onChangeRanges={handleChangeDateRanges}
          rangeValue={{ startDate: filters?.startDate, endDate: filters?.endDate }}
        />
        <RegionsSelect regions={regions} value={filters?.regionId} onChange={handleChangeRegion} />
      </Styles.FiltersSubContainer>
    </Styles.FiltersContainer>
  )
}

export default FiltersSection
